/**
 * Banda magenta horizontal animada — firma visual de PAWTRAiT.
 * Texto repetido en marquee continuo.
 */
const ITEMS = Array.from({ length: 8 }, (_, i) => i);

const MagentaBand = ({
  text = "Arte que celebra el amor por nuestras mascotas",
}: {
  text?: string;
}) => {
  return (
    <div className="bg-secondary py-3 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...ITEMS, ...ITEMS].map((i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 px-6 text-sm font-medium tracking-wide text-secondary-foreground"
          >
            <span aria-hidden>🐾</span>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default MagentaBand;
